import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SponsoredContentComponent } from './sponsored-content/sponsored-content.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SponsoredContentComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SponsoredContentModule { }
